/**
 * Core domain model.
 * Deliberately transport-agnostic: REST, SSE and WebSocket adapters all
 * normalise into these shapes, so the UI never learns how bytes arrived.
 */
export function chatError(code, message, opts = {}) {
    return {
        code,
        message,
        retryable: opts.retryable ?? (code === 'network' || code === 'timeout' || code === 'server'),
        cause: opts.cause,
    };
}
